import { render } from "./PageNotFound.vue?vue&type=template&id=43bf4e44"
const script = {}

import exportComponent from "/var/www/landing2.elena-dating.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__